import { useNavigate } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

interface AdminLandingCardProps {
  title: string
  description: string
  to: string
  icon: React.ComponentType<{ className?: string }>
}

export function AdminLandingCard({ title, description, to, icon: Icon }: AdminLandingCardProps) {
  const navigate = useNavigate()

  return (
    <button
      onClick={() => navigate(to)}
      className="flex items-start gap-4 rounded-xl border border-neutral-200 bg-white p-5 text-left transition-all hover:border-primary/30 hover:shadow-md"
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10">
        <Icon className="h-5 w-5 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-neutral-900">{title}</h3>
        <p className="mt-1 text-xs text-neutral-500">{description}</p>
      </div>
      <ChevronRight className="mt-0.5 h-4 w-4 shrink-0 text-neutral-400" />
    </button>
  )
}
